interface ScenarioCardProps {
  number: string;
  title: string;
  applicableFor: string;
  challenges: string[];
  mechanism: string;
  recommendations: string;
  buttonText: string;
  onButtonClick: () => void;
  onConsultClick: () => void;
}

export default function ScenarioCard({
  number,
  title,
  applicableFor,
  challenges,
  mechanism,
  recommendations,
  buttonText,
  onButtonClick,
  onConsultClick,
}: ScenarioCardProps) {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-8 hover:shadow-lg transition-shadow">
      {/* 标题区 */}
      <div className="mb-6">
        <div className="text-sm text-[#14B8A6] font-medium mb-2">方案{number}</div>
        <h3 className="text-2xl font-bold text-gray-900 mb-3">{title}</h3>
      </div>

      {/* 适用对象 */}
      <div className="mb-6">
        <h4 className="text-base font-semibold text-gray-900 mb-3">适用对象</h4>
        <p className="text-sm text-gray-700 leading-relaxed">{applicableFor}</p>
      </div>

      {/* 管理难点 */}
      <div className="mb-6">
        <h4 className="text-base font-semibold text-gray-900 mb-3">管理难点</h4>
        <ul className="space-y-2">
          {challenges.map((challenge, index) => (
            <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
              <span className="text-gray-400 mt-1">•</span>
              <span>{challenge}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* 方案机制 */}
      <div className="mb-6">
        <h4 className="text-base font-semibold text-gray-900 mb-3">方案机制</h4>
        <p className="text-sm text-gray-700 leading-relaxed">{mechanism}</p>
      </div>

      {/* 推荐组合 */}
      <div className="mb-6">
        <h4 className="text-base font-semibold text-gray-900 mb-3">推荐组合</h4>
        <p className="text-sm text-gray-700 leading-relaxed">{recommendations}</p>
      </div>

      {/* 操作按钮 */}
      <div className="flex gap-3">
        <button
          onClick={onConsultClick}
          className="flex-1 px-6 py-3 bg-white border-2 border-[#14B8A6] text-[#14B8A6] text-sm font-medium rounded-lg hover:bg-[#14B8A6] hover:text-white transition-colors cursor-pointer whitespace-nowrap"
        >
          咨询方案
        </button>
        <button
          onClick={onButtonClick}
          className="flex-1 px-6 py-3 bg-[#14B8A6] text-white text-sm font-medium rounded-lg hover:bg-[#0F9A8A] transition-colors cursor-pointer whitespace-nowrap"
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
}